import React, { Component } from 'react';

class EmptyLayout extends Component {
    render() {
        return (
            <div className="root-div">
                <div className="full-wrap">{this.props.children}</div>
            </div>
        );
    }
}

export default EmptyLayout;
